import { CommonModule } from '@angular/common';
import { Component, computed, Signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core/auth/auth.service';
import { PwaInstallPromptComponent } from './layout/common/pwa/install-prompt/install-prompt.component';
import { PwaOfflineIndicatorComponent } from './layout/common/pwa/offline-indicator/offline-indicator.component';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet,
        MatIconModule,
        CommonModule,
        PwaOfflineIndicatorComponent,
        PwaInstallPromptComponent,
    ]
})
export class AppComponent {
    public displayButtonsParams = false;
    public isLoggedIn: Signal<boolean>;

    /**
     * Constructor
     */
    constructor(
        private authService: AuthService,
        private matDialog: MatDialog,
    ) {
        this.isLoggedIn = computed(() => !!this.authService.user());
    }

    displayButtons() {
        this.displayButtonsParams = !this.displayButtonsParams;
    }
}
